"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A316))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.436Z
 */
export const Clipboard = createSVGIcon(
  <>
    <path
      d="M18.018 17.562C18.3285 17.2 18.4995 16.7389 18.5 16.262V5.5H5.5V20.5H14.58C14.8687 20.4999 15.154 20.4372 15.4162 20.3164C15.6784 20.1956 15.9113 20.0194 16.099 19.8L18.018 17.562Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 2.49981H15.052C14.7926 1.90677 14.3659 1.40222 13.8242 1.0479C13.2825 0.693588 12.6493 0.504883 12.002 0.504883C11.3547 0.504883 10.7215 0.693588 10.1798 1.0479C9.63806 1.40222 9.2114 1.90677 8.952 2.49981H3.5C3.23478 2.49981 2.98043 2.60517 2.79289 2.79271C2.60536 2.98024 2.5 3.2346 2.5 3.49981V22.4998C2.5 22.765 2.60536 23.0194 2.79289 23.2069C2.98043 23.3945 3.23478 23.4998 3.5 23.4998H20.5C20.7652 23.4998 21.0196 23.3945 21.2071 23.2069C21.3946 23.0194 21.5 22.765 21.5 22.4998V3.49981C21.5 3.2346 21.3946 2.98024 21.2071 2.79271C21.0196 2.60517 20.7652 2.49981 20.5 2.49981V2.49981Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 8.5H8.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 12.5H8.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 16.5H8.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Clipboard",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Copy",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
